import modal from '@/components/modal.js'
import { getCookie, setCookie } from '@/lib/helpers.js'

const key = 'swedenrock.age.verified'

export default () => ({
    ...modal(),

    init() {
        this.isActive = !getCookie(key, false)
    },

    accept() {
        const expiresInDays = 365

        setCookie(key, true, expiresInDays)

        this.isActive = false
    },
})
